import {connect} from "react-redux";
import StudentProfile from '../../components/StudentProfile/StudentProfile';
import * as AdminActions from "../../store/actions/adminActions";
import * as StudentActions from "../../store/actions/studentActions";

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.adminInfo,
    ...state.studentLocation
});

const mapDispatchToProps = (dispatch) => ({
    getStudentProfile: (id, token) => {
      dispatch(AdminActions.getInfoAboutStudent(id, token))
    },
    getLogins: (user, token) => {
        dispatch(StudentActions.GetLogins(user, token));
    }

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentProfile);


// WEBPACK FOOTER //
// ./src/containers/StudentProfile/StudentProfileContainer.js